export default __webpack_public_path__ + "static/media/Exaltate's Armbands.1f51541e.jpg";